import React from "react";
import * as styled from "../../components/subpageHeroArea/ApplicationSubpageStyled";
import {useRouter} from 'next/router';
import Image from "next/image";


const BreadcrumbComp = () => {
    const router = useRouter()

    return (
        <styled.BreadcrumbContainer>
            <div className={'breadcrumb-wrapper'}>
                <div className={'breadcrumb-link'}>
                    <div onClick={() => router.back()}>
                        <Image loading={'lazy'} width={13}
                               height={25}
                               sizes={'100vw'}
                               style={{width: '100%', height: 'auto'}}
                               src={`/next/assets/images/career/left-arrow.svg`}
                               alt={'Pembe Panjur'} title={'Pembe Panjur'}
                        />
                        <span>Geri dön</span>
                    </div>
                </div>
                <div className={'breadcrumb-link'}>
                    <div>
                        <span>Başvuru gönder</span>
                    </div>
                </div>
            </div>
        </styled.BreadcrumbContainer>
    )
}

export default BreadcrumbComp;
